import(/* webpackMode: "eager" */ "/app/app/l/[slug]/error.tsx");
